var map = {
	"./ar/card-sets/3dartists.json": [
		51752,
		51752
	],
	"./ar/card-sets/accountants.json": [
		52360,
		52360
	],
	"./ar/card-sets/airbnbhosts.json": [
		1204,
		1204
	],
	"./ar/card-sets/analysts.json": [
		15442,
		15442
	],
	"./ar/card-sets/appraisers.json": [
		33995,
		33995
	],
	"./ar/card-sets/architects.json": [
		49513,
		49513
	],
	"./ar/card-sets/auditors.json": [
		94482,
		94482
	],
	"./ar/card-sets/bookkeepers.json": [
		12793,
		12793
	],
	"./ar/card-sets/boss.json": [
		6488,
		6488
	],
	"./ar/card-sets/businessowners.json": [
		79051,
		79051
	],
	"./ar/card-sets/cfo.json": [
		55303,
		55303
	],
	"./ar/card-sets/chiropractors.json": [
		10992,
		10992
	],
	"./ar/card-sets/civilengineers.json": [
		15134,
		15134
	],
	"./ar/card-sets/civilservants.json": [
		54848,
		54848
	],
	"./ar/card-sets/cleaningbusiness.json": [
		16064,
		16064
	],
	"./ar/card-sets/compliance.json": [
		89942,
		89942
	],
	"./ar/card-sets/constructionmanagers.json": [
		47188,
		47188
	],
	"./ar/card-sets/consultants.json": [
		48503,
		48503
	],
	"./ar/card-sets/contractors.json": [
		23433,
		23433
	],
	"./ar/card-sets/cruiseagents.json": [
		46936,
		46936
	],
	"./ar/card-sets/customsbrokers.json": [
		68919,
		68919
	],
	"./ar/card-sets/dentists.json": [
		39217,
		39217
	],
	"./ar/card-sets/designers.json": [
		33023,
		33023
	],
	"./ar/card-sets/ecommercesellers.json": [
		48737,
		48737
	],
	"./ar/card-sets/engineers.json": [
		13803,
		13803
	],
	"./ar/card-sets/estimators.json": [
		77170,
		77170
	],
	"./ar/card-sets/events.json": [
		2488,
		2488
	],
	"./ar/card-sets/excel.json": [
		32678,
		10297
	],
	"./ar/card-sets/executiveassistants.json": [
		24014,
		24014
	],
	"./ar/card-sets/financialadvisors.json": [
		93895,
		93895
	],
	"./ar/card-sets/financiers.json": [
		11883,
		11883
	],
	"./ar/card-sets/fitnesstrainers.json": [
		16531,
		16531
	],
	"./ar/card-sets/freelancers.json": [
		60887,
		60887
	],
	"./ar/card-sets/freightbrokers.json": [
		33706,
		33706
	],
	"./ar/card-sets/general.json": [
		82469,
		82469
	],
	"./ar/card-sets/grantwriters.json": [
		45639,
		45639
	],
	"./ar/card-sets/healthcare.json": [
		95530,
		95530
	],
	"./ar/card-sets/hospitality.json": [
		43319,
		43319
	],
	"./ar/card-sets/hr.json": [
		36199,
		36199
	],
	"./ar/card-sets/insuranceagents.json": [
		3915,
		3915
	],
	"./ar/card-sets/interiordesigners.json": [
		1503,
		1503
	],
	"./ar/card-sets/landscapers.json": [
		58747,
		58747
	],
	"./ar/card-sets/languageteachers.json": [
		15084,
		15084
	],
	"./ar/card-sets/lawyers.json": [
		52248,
		52248
	],
	"./ar/card-sets/loanofficers.json": [
		22248,
		22248
	],
	"./ar/card-sets/logistics.json": [
		63886,
		63886
	],
	"./ar/card-sets/marketers.json": [
		27345,
		27345
	],
	"./ar/card-sets/medicalcoders.json": [
		11204,
		11204
	],
	"./ar/card-sets/mepengineers.json": [
		41273,
		41273
	],
	"./ar/card-sets/microsoft365.json": [
		17817,
		17817
	],
	"./ar/card-sets/mortgagebrokers.json": [
		16625,
		16625
	],
	"./ar/card-sets/motiondesigners.json": [
		85301,
		85301
	],
	"./ar/card-sets/notaries.json": [
		80384,
		80384
	],
	"./ar/card-sets/novels.json": [
		13798,
		13798
	],
	"./ar/card-sets/nurses.json": [
		5667,
		5667
	],
	"./ar/card-sets/nutritionists.json": [
		74804,
		74804
	],
	"./ar/card-sets/officemanagers.json": [
		20201,
		20201
	],
	"./ar/card-sets/onlinecoaches.json": [
		13186,
		13186
	],
	"./ar/card-sets/paralegals.json": [
		793,
		793
	],
	"./ar/card-sets/payroll.json": [
		38960,
		38960
	],
	"./ar/card-sets/pharmacists.json": [
		22870,
		22870
	],
	"./ar/card-sets/photographers.json": [
		40617,
		40617
	],
	"./ar/card-sets/physicaltherapists.json": [
		87591,
		87591
	],
	"./ar/card-sets/procurement.json": [
		89303,
		89303
	],
	"./ar/card-sets/programmers.json": [
		97080,
		97080
	],
	"./ar/card-sets/projectmanagers.json": [
		96596,
		96596
	],
	"./ar/card-sets/propertymanagers.json": [
		93528,
		93528
	],
	"./ar/card-sets/psychologists.json": [
		22342,
		22342
	],
	"./ar/card-sets/quantitysurveyors.json": [
		76562,
		76562
	],
	"./ar/card-sets/realestate.json": [
		63601,
		63601
	],
	"./ar/card-sets/recruiters.json": [
		30951,
		30951
	],
	"./ar/card-sets/safetymanagers.json": [
		7515,
		7515
	],
	"./ar/card-sets/salesmanagers.json": [
		21449,
		21449
	],
	"./ar/card-sets/salonowners.json": [
		57964,
		57964
	],
	"./ar/card-sets/shortdramas.json": [
		10119,
		10119
	],
	"./ar/card-sets/structuralengineers.json": [
		76358,
		76358
	],
	"./ar/card-sets/supplychain.json": [
		43381,
		43381
	],
	"./ar/card-sets/supportmanagers.json": [
		82890,
		82890
	],
	"./ar/card-sets/surveyors.json": [
		48301,
		48301
	],
	"./ar/card-sets/taxadvisors.json": [
		20093,
		20093
	],
	"./ar/card-sets/teachers.json": [
		1730,
		1730
	],
	"./ar/card-sets/tourguides.json": [
		39206,
		39206
	],
	"./ar/card-sets/touroperators.json": [
		53246,
		53246
	],
	"./ar/card-sets/travel.json": [
		52665,
		52665
	],
	"./ar/card-sets/tutors.json": [
		51780,
		51780
	],
	"./ar/card-sets/veterinarians.json": [
		31992,
		31992
	],
	"./ar/card-sets/videoeditors.json": [
		78498,
		78498
	],
	"./de/card-sets/3dartists.json": [
		14076,
		14076
	],
	"./de/card-sets/accountants.json": [
		13716,
		13716
	],
	"./de/card-sets/airbnbhosts.json": [
		46408,
		46408
	],
	"./de/card-sets/analysts.json": [
		48334,
		48334
	],
	"./de/card-sets/appraisers.json": [
		53927,
		53927
	],
	"./de/card-sets/architects.json": [
		37621,
		37621
	],
	"./de/card-sets/auditors.json": [
		45446,
		45446
	],
	"./de/card-sets/bookkeepers.json": [
		11853,
		11853
	],
	"./de/card-sets/boss.json": [
		9732,
		9732
	],
	"./de/card-sets/businessowners.json": [
		58471,
		58471
	],
	"./de/card-sets/cfo.json": [
		62595,
		62595
	],
	"./de/card-sets/chiropractors.json": [
		99223,
		21604
	],
	"./de/card-sets/civilengineers.json": [
		66946,
		66946
	],
	"./de/card-sets/civilservants.json": [
		38364,
		38364
	],
	"./de/card-sets/cleaningbusiness.json": [
		77300,
		77300
	],
	"./de/card-sets/compliance.json": [
		70674,
		70674
	],
	"./de/card-sets/constructionmanagers.json": [
		12944,
		12944
	],
	"./de/card-sets/consultants.json": [
		87323,
		87323
	],
	"./de/card-sets/contractors.json": [
		41309,
		41309
	],
	"./de/card-sets/cruiseagents.json": [
		73196,
		73196
	],
	"./de/card-sets/customsbrokers.json": [
		35467,
		35467
	],
	"./de/card-sets/dentists.json": [
		87389,
		87389
	],
	"./de/card-sets/designers.json": [
		33203,
		33203
	],
	"./de/card-sets/ecommercesellers.json": [
		63477,
		63477
	],
	"./de/card-sets/engineers.json": [
		87223,
		87223
	],
	"./de/card-sets/estimators.json": [
		798,
		798
	],
	"./de/card-sets/events.json": [
		91652,
		91652
	],
	"./de/card-sets/excel.json": [
		19034,
		19034
	],
	"./de/card-sets/executiveassistants.json": [
		12770,
		12770
	],
	"./de/card-sets/financialadvisors.json": [
		68475,
		68475
	],
	"./de/card-sets/financiers.json": [
		8015,
		8015
	],
	"./de/card-sets/fitnesstrainers.json": [
		65159,
		65159
	],
	"./de/card-sets/freelancers.json": [
		80339,
		80339
	],
	"./de/card-sets/freightbrokers.json": [
		23422,
		23422
	],
	"./de/card-sets/general.json": [
		44505,
		44505
	],
	"./de/card-sets/grantwriters.json": [
		85995,
		85995
	],
	"./de/card-sets/healthcare.json": [
		2494,
		2494
	],
	"./de/card-sets/hospitality.json": [
		73827,
		73827
	],
	"./de/card-sets/hr.json": [
		69691,
		69691
	],
	"./de/card-sets/insuranceagents.json": [
		51575,
		51575
	],
	"./de/card-sets/interiordesigners.json": [
		20931,
		20931
	],
	"./de/card-sets/landscapers.json": [
		20343,
		20343
	],
	"./de/card-sets/languageteachers.json": [
		43736,
		43736
	],
	"./de/card-sets/lawyers.json": [
		90588,
		90588
	],
	"./de/card-sets/loanofficers.json": [
		90388,
		90388
	],
	"./de/card-sets/logistics.json": [
		90074,
		90074
	],
	"./de/card-sets/marketers.json": [
		53453,
		53453
	],
	"./de/card-sets/medicalcoders.json": [
		89000,
		89000
	],
	"./de/card-sets/mepengineers.json": [
		21101,
		21101
	],
	"./de/card-sets/microsoft365.json": [
		78837,
		78837
	],
	"./de/card-sets/mortgagebrokers.json": [
		63322,
		40941
	],
	"./de/card-sets/motiondesigners.json": [
		89121,
		89121
	],
	"./de/card-sets/notaries.json": [
		36644,
		36644
	],
	"./de/card-sets/novels.json": [
		89810,
		89810
	],
	"./de/card-sets/nurses.json": [
		11631,
		11631
	],
	"./de/card-sets/nutritionists.json": [
		91960,
		91960
	],
	"./de/card-sets/officemanagers.json": [
		62861,
		62861
	],
	"./de/card-sets/onlinecoaches.json": [
		29270,
		29270
	],
	"./de/card-sets/paralegals.json": [
		78957,
		78957
	],
	"./de/card-sets/payroll.json": [
		66468,
		66468
	],
	"./de/card-sets/pharmacists.json": [
		62434,
		62434
	],
	"./de/card-sets/photographers.json": [
		59549,
		59549
	],
	"./de/card-sets/physicaltherapists.json": [
		81067,
		81067
	],
	"./de/card-sets/procurement.json": [
		61739,
		61739
	],
	"./de/card-sets/programmers.json": [
		23884,
		23884
	],
	"./de/card-sets/projectmanagers.json": [
		44920,
		44920
	],
	"./de/card-sets/propertymanagers.json": [
		26468,
		26468
	],
	"./de/card-sets/psychologists.json": [
		19770,
		19770
	],
	"./de/card-sets/quantitysurveyors.json": [
		36318,
		36318
	],
	"./de/card-sets/realestate.json": [
		56517,
		56517
	],
	"./de/card-sets/recruiters.json": [
		45771,
		45771
	],
	"./de/card-sets/safetymanagers.json": [
		63607,
		63607
	],
	"./de/card-sets/salesmanagers.json": [
		60818,
		38437
	],
	"./de/card-sets/salonowners.json": [
		62192,
		62192
	],
	"./de/card-sets/shortdramas.json": [
		4547,
		4547
	],
	"./de/card-sets/structuralengineers.json": [
		93338,
		93338
	],
	"./de/card-sets/supplychain.json": [
		86137,
		86137
	],
	"./de/card-sets/supportmanagers.json": [
		26878,
		26878
	],
	"./de/card-sets/surveyors.json": [
		7737,
		7737
	],
	"./de/card-sets/taxadvisors.json": [
		2441,
		2441
	],
	"./de/card-sets/teachers.json": [
		30926,
		30926
	],
	"./de/card-sets/tourguides.json": [
		49122,
		49122
	],
	"./de/card-sets/touroperators.json": [
		4546,
		4546
	],
	"./de/card-sets/travel.json": [
		45869,
		45869
	],
	"./de/card-sets/tutors.json": [
		4072,
		4072
	],
	"./de/card-sets/veterinarians.json": [
		93300,
		93300
	],
	"./de/card-sets/videoeditors.json": [
		47302,
		47302
	],
	"./es/card-sets/3dartists.json": [
		91087,
		91087
	],
	"./es/card-sets/accountants.json": [
		93415,
		93415
	],
	"./es/card-sets/airbnbhosts.json": [
		62711,
		62711
	],
	"./es/card-sets/analysts.json": [
		94891,
		94891
	],
	"./es/card-sets/appraisers.json": [
		86626,
		86626
	],
	"./es/card-sets/architects.json": [
		41928,
		41928
	],
	"./es/card-sets/auditors.json": [
		95660,
		73279
	],
	"./es/card-sets/bookkeepers.json": [
		69722,
		69722
	],
	"./es/card-sets/boss.json": [
		47101,
		47101
	],
	"./es/card-sets/businessowners.json": [
		40406,
		40406
	],
	"./es/card-sets/cfo.json": [
		18116,
		18116
	],
	"./es/card-sets/chiropractors.json": [
		37715,
		37715
	],
	"./es/card-sets/civilengineers.json": [
		727,
		727
	],
	"./es/card-sets/civilservants.json": [
		17999,
		17999
	],
	"./es/card-sets/cleaningbusiness.json": [
		39953,
		39953
	],
	"./es/card-sets/compliance.json": [
		62695,
		62695
	],
	"./es/card-sets/constructionmanagers.json": [
		26809,
		26809
	],
	"./es/card-sets/consultants.json": [
		92636,
		92636
	],
	"./es/card-sets/contractors.json": [
		66266,
		66266
	],
	"./es/card-sets/cruiseagents.json": [
		59661,
		59661
	],
	"./es/card-sets/customsbrokers.json": [
		95754,
		95754
	],
	"./es/card-sets/dentists.json": [
		34904,
		34904
	],
	"./es/card-sets/designers.json": [
		57416,
		57416
	],
	"./es/card-sets/ecommercesellers.json": [
		53056,
		53056
	],
	"./es/card-sets/engineers.json": [
		56620,
		56620
	],
	"./es/card-sets/estimators.json": [
		11055,
		11055
	],
	"./es/card-sets/events.json": [
		29634,
		7253
	],
	"./es/card-sets/excel.json": [
		75369,
		75369
	],
	"./es/card-sets/executiveassistants.json": [
		96393,
		96393
	],
	"./es/card-sets/financialadvisors.json": [
		89744,
		89744
	],
	"./es/card-sets/financiers.json": [
		72634,
		72634
	],
	"./es/card-sets/fitnesstrainers.json": [
		80296,
		80296
	],
	"./es/card-sets/freelancers.json": [
		23528,
		23528
	],
	"./es/card-sets/freightbrokers.json": [
		59351,
		59351
	],
	"./es/card-sets/general.json": [
		28722,
		28722
	],
	"./es/card-sets/grantwriters.json": [
		24986,
		24986
	],
	"./es/card-sets/healthcare.json": [
		46248,
		23867
	],
	"./es/card-sets/hospitality.json": [
		54440,
		54440
	],
	"./es/card-sets/hr.json": [
		49630,
		49630
	],
	"./es/card-sets/insuranceagents.json": [
		40800,
		40800
	],
	"./es/card-sets/interiordesigners.json": [
		59568,
		59568
	],
	"./es/card-sets/landscapers.json": [
		49172,
		49172
	],
	"./es/card-sets/languageteachers.json": [
		3949,
		3949
	],
	"./es/card-sets/lawyers.json": [
		48475,
		48475
	],
	"./es/card-sets/loanofficers.json": [
		58077,
		58077
	],
	"./es/card-sets/logistics.json": [
		30633,
		30633
	],
	"./es/card-sets/marketers.json": [
		6914,
		6914
	],
	"./es/card-sets/medicalcoders.json": [
		94155,
		94155
	],
	"./es/card-sets/mepengineers.json": [
		33148,
		33148
	],
	"./es/card-sets/microsoft365.json": [
		47628,
		47628
	],
	"./es/card-sets/mortgagebrokers.json": [
		52626,
		52626
	],
	"./es/card-sets/motiondesigners.json": [
		44350,
		44350
	],
	"./es/card-sets/notaries.json": [
		84901,
		84901
	],
	"./es/card-sets/novels.json": [
		71351,
		71351
	],
	"./es/card-sets/nurses.json": [
		35234,
		35234
	],
	"./es/card-sets/nutritionists.json": [
		58071,
		58071
	],
	"./es/card-sets/officemanagers.json": [
		96292,
		96292
	],
	"./es/card-sets/onlinecoaches.json": [
		22721,
		22721
	],
	"./es/card-sets/paralegals.json": [
		95204,
		95204
	],
	"./es/card-sets/payroll.json": [
		46647,
		46647
	],
	"./es/card-sets/pharmacists.json": [
		51809,
		51809
	],
	"./es/card-sets/photographers.json": [
		62338,
		62338
	],
	"./es/card-sets/physicaltherapists.json": [
		48710,
		48710
	],
	"./es/card-sets/procurement.json": [
		56264,
		56264
	],
	"./es/card-sets/programmers.json": [
		24015,
		24015
	],
	"./es/card-sets/projectmanagers.json": [
		45719,
		45719
	],
	"./es/card-sets/propertymanagers.json": [
		11533,
		11533
	],
	"./es/card-sets/psychologists.json": [
		46185,
		46185
	],
	"./es/card-sets/quantitysurveyors.json": [
		30681,
		30681
	],
	"./es/card-sets/realestate.json": [
		24864,
		24864
	],
	"./es/card-sets/recruiters.json": [
		56242,
		56242
	],
	"./es/card-sets/safetymanagers.json": [
		93990,
		93990
	],
	"./es/card-sets/salesmanagers.json": [
		44518,
		44518
	],
	"./es/card-sets/salonowners.json": [
		47967,
		47967
	],
	"./es/card-sets/shortdramas.json": [
		19220,
		19220
	],
	"./es/card-sets/structuralengineers.json": [
		90525,
		90525
	],
	"./es/card-sets/supplychain.json": [
		38034,
		38034
	],
	"./es/card-sets/supportmanagers.json": [
		95213,
		95213
	],
	"./es/card-sets/surveyors.json": [
		55190,
		55190
	],
	"./es/card-sets/taxadvisors.json": [
		12014,
		12014
	],
	"./es/card-sets/teachers.json": [
		9455,
		9455
	],
	"./es/card-sets/tourguides.json": [
		26307,
		26307
	],
	"./es/card-sets/touroperators.json": [
		36025,
		36025
	],
	"./es/card-sets/travel.json": [
		49284,
		49284
	],
	"./es/card-sets/tutors.json": [
		66581,
		66581
	],
	"./es/card-sets/veterinarians.json": [
		4463,
		4463
	],
	"./es/card-sets/videoeditors.json": [
		59695,
		59695
	],
	"./fr/card-sets/3dartists.json": [
		42403,
		42403
	],
	"./fr/card-sets/accountants.json": [
		18899,
		18899
	],
	"./fr/card-sets/airbnbhosts.json": [
		67851,
		67851
	],
	"./fr/card-sets/analysts.json": [
		21671,
		21671
	],
	"./fr/card-sets/appraisers.json": [
		99342,
		99342
	],
	"./fr/card-sets/architects.json": [
		94372,
		94372
	],
	"./fr/card-sets/auditors.json": [
		14739,
		14739
	],
	"./fr/card-sets/bookkeepers.json": [
		2526,
		2526
	],
	"./fr/card-sets/boss.json": [
		98457,
		98457
	],
	"./fr/card-sets/businessowners.json": [
		26418,
		26418
	],
	"./fr/card-sets/cfo.json": [
		72528,
		72528
	],
	"./fr/card-sets/chiropractors.json": [
		96567,
		96567
	],
	"./fr/card-sets/civilengineers.json": [
		17195,
		17195
	],
	"./fr/card-sets/civilservants.json": [
		51083,
		51083
	],
	"./fr/card-sets/cleaningbusiness.json": [
		77573,
		77573
	],
	"./fr/card-sets/compliance.json": [
		91603,
		91603
	],
	"./fr/card-sets/constructionmanagers.json": [
		68965,
		68965
	],
	"./fr/card-sets/consultants.json": [
		71715,
		94096
	],
	"./fr/card-sets/contractors.json": [
		46190,
		46190
	],
	"./fr/card-sets/cruiseagents.json": [
		76673,
		76673
	],
	"./fr/card-sets/customsbrokers.json": [
		12846,
		12846
	],
	"./fr/card-sets/dentists.json": [
		18279,
		40660
	],
	"./fr/card-sets/designers.json": [
		70636,
		70636
	],
	"./fr/card-sets/ecommercesellers.json": [
		68804,
		68804
	],
	"./fr/card-sets/engineers.json": [
		51704,
		51704
	],
	"./fr/card-sets/estimators.json": [
		42667,
		42667
	],
	"./fr/card-sets/events.json": [
		68001,
		68001
	],
	"./fr/card-sets/excel.json": [
		98941,
		98941
	],
	"./fr/card-sets/executiveassistants.json": [
		12093,
		12093
	],
	"./fr/card-sets/financialadvisors.json": [
		19076,
		19076
	],
	"./fr/card-sets/financiers.json": [
		94942,
		94942
	],
	"./fr/card-sets/fitnesstrainers.json": [
		12780,
		12780
	],
	"./fr/card-sets/freelancers.json": [
		52900,
		52900
	],
	"./fr/card-sets/freightbrokers.json": [
		94987,
		94987
	],
	"./fr/card-sets/general.json": [
		20646,
		20646
	],
	"./fr/card-sets/grantwriters.json": [
		53998,
		53998
	],
	"./fr/card-sets/healthcare.json": [
		89151,
		89151
	],
	"./fr/card-sets/hospitality.json": [
		70020,
		70020
	],
	"./fr/card-sets/hr.json": [
		95890,
		95890
	],
	"./fr/card-sets/insuranceagents.json": [
		71964,
		71964
	],
	"./fr/card-sets/interiordesigners.json": [
		78244,
		78244
	],
	"./fr/card-sets/landscapers.json": [
		6464,
		6464
	],
	"./fr/card-sets/languageteachers.json": [
		78601,
		78601
	],
	"./fr/card-sets/lawyers.json": [
		95295,
		95295
	],
	"./fr/card-sets/loanofficers.json": [
		70489,
		70489
	],
	"./fr/card-sets/logistics.json": [
		10386,
		88005
	],
	"./fr/card-sets/marketers.json": [
		59486,
		59486
	],
	"./fr/card-sets/medicalcoders.json": [
		66751,
		66751
	],
	"./fr/card-sets/mepengineers.json": [
		272,
		272
	],
	"./fr/card-sets/microsoft365.json": [
		45192,
		45192
	],
	"./fr/card-sets/mortgagebrokers.json": [
		63518,
		63518
	],
	"./fr/card-sets/motiondesigners.json": [
		73258,
		73258
	],
	"./fr/card-sets/notaries.json": [
		27417,
		27417
	],
	"./fr/card-sets/novels.json": [
		2499,
		2499
	],
	"./fr/card-sets/nurses.json": [
		64398,
		64398
	],
	"./fr/card-sets/nutritionists.json": [
		86619,
		86619
	],
	"./fr/card-sets/officemanagers.json": [
		58728,
		58728
	],
	"./fr/card-sets/onlinecoaches.json": [
		22437,
		22437
	],
	"./fr/card-sets/paralegals.json": [
		64520,
		64520
	],
	"./fr/card-sets/payroll.json": [
		55403,
		55403
	],
	"./fr/card-sets/pharmacists.json": [
		88813,
		88813
	],
	"./fr/card-sets/photographers.json": [
		69062,
		69062
	],
	"./fr/card-sets/physicaltherapists.json": [
		72797,
		95178
	],
	"./fr/card-sets/procurement.json": [
		11980,
		11980
	],
	"./fr/card-sets/programmers.json": [
		71507,
		71507
	],
	"./fr/card-sets/projectmanagers.json": [
		95163,
		95163
	],
	"./fr/card-sets/propertymanagers.json": [
		87305,
		87305
	],
	"./fr/card-sets/psychologists.json": [
		41277,
		41277
	],
	"./fr/card-sets/quantitysurveyors.json": [
		69509,
		69509
	],
	"./fr/card-sets/realestate.json": [
		50484,
		50484
	],
	"./fr/card-sets/recruiters.json": [
		10297,
		32678
	],
	"./fr/card-sets/safetymanagers.json": [
		11474,
		11474
	],
	"./fr/card-sets/salesmanagers.json": [
		21922,
		21922
	],
	"./fr/card-sets/salonowners.json": [
		41203,
		41203
	],
	"./fr/card-sets/shortdramas.json": [
		54832,
		54832
	],
	"./fr/card-sets/structuralengineers.json": [
		38001,
		38001
	],
	"./fr/card-sets/supplychain.json": [
		48166,
		48166
	],
	"./fr/card-sets/supportmanagers.json": [
		39969,
		39969
	],
	"./fr/card-sets/surveyors.json": [
		61458,
		61458
	],
	"./fr/card-sets/taxadvisors.json": [
		48506,
		48506
	],
	"./fr/card-sets/teachers.json": [
		48795,
		48795
	],
	"./fr/card-sets/tourguides.json": [
		6687,
		6687
	],
	"./fr/card-sets/touroperators.json": [
		26445,
		26445
	],
	"./fr/card-sets/travel.json": [
		13160,
		13160
	],
	"./fr/card-sets/tutors.json": [
		71913,
		71913
	],
	"./fr/card-sets/veterinarians.json": [
		5707,
		5707
	],
	"./fr/card-sets/videoeditors.json": [
		68195,
		68195
	],
	"./it/card-sets/3dartists.json": [
		71622,
		71622
	],
	"./it/card-sets/accountants.json": [
		10182,
		10182
	],
	"./it/card-sets/airbnbhosts.json": [
		13526,
		13526
	],
	"./it/card-sets/analysts.json": [
		15000,
		15000
	],
	"./it/card-sets/appraisers.json": [
		73293,
		73293
	],
	"./it/card-sets/architects.json": [
		27771,
		27771
	],
	"./it/card-sets/auditors.json": [
		31328,
		31328
	],
	"./it/card-sets/bookkeepers.json": [
		45275,
		45275
	],
	"./it/card-sets/boss.json": [
		4642,
		4642
	],
	"./it/card-sets/businessowners.json": [
		24181,
		24181
	],
	"./it/card-sets/cfo.json": [
		61321,
		61321
	],
	"./it/card-sets/chiropractors.json": [
		25190,
		25190
	],
	"./it/card-sets/civilengineers.json": [
		95060,
		95060
	],
	"./it/card-sets/civilservants.json": [
		50930,
		50930
	],
	"./it/card-sets/cleaningbusiness.json": [
		92358,
		92358
	],
	"./it/card-sets/compliance.json": [
		47984,
		47984
	],
	"./it/card-sets/constructionmanagers.json": [
		4878,
		4878
	],
	"./it/card-sets/consultants.json": [
		35309,
		35309
	],
	"./it/card-sets/contractors.json": [
		7111,
		7111
	],
	"./it/card-sets/cruiseagents.json": [
		1530,
		1530
	],
	"./it/card-sets/customsbrokers.json": [
		69433,
		69433
	],
	"./it/card-sets/dentists.json": [
		27535,
		27535
	],
	"./it/card-sets/designers.json": [
		45801,
		45801
	],
	"./it/card-sets/ecommercesellers.json": [
		33423,
		33423
	],
	"./it/card-sets/engineers.json": [
		52277,
		52277
	],
	"./it/card-sets/estimators.json": [
		70028,
		70028
	],
	"./it/card-sets/events.json": [
		2518,
		2518
	],
	"./it/card-sets/excel.json": [
		96824,
		96824
	],
	"./it/card-sets/executiveassistants.json": [
		56376,
		56376
	],
	"./it/card-sets/financialadvisors.json": [
		61417,
		61417
	],
	"./it/card-sets/financiers.json": [
		47765,
		47765
	],
	"./it/card-sets/fitnesstrainers.json": [
		74689,
		74689
	],
	"./it/card-sets/freelancers.json": [
		7621,
		7621
	],
	"./it/card-sets/freightbrokers.json": [
		98768,
		98768
	],
	"./it/card-sets/general.json": [
		75271,
		75271
	],
	"./it/card-sets/grantwriters.json": [
		62125,
		62125
	],
	"./it/card-sets/healthcare.json": [
		13476,
		13476
	],
	"./it/card-sets/hospitality.json": [
		82293,
		82293
	],
	"./it/card-sets/hr.json": [
		54901,
		54901
	],
	"./it/card-sets/insuranceagents.json": [
		73289,
		73289
	],
	"./it/card-sets/interiordesigners.json": [
		47305,
		47305
	],
	"./it/card-sets/landscapers.json": [
		3421,
		3421
	],
	"./it/card-sets/languageteachers.json": [
		20678,
		20678
	],
	"./it/card-sets/lawyers.json": [
		78210,
		78210
	],
	"./it/card-sets/loanofficers.json": [
		96978,
		96978
	],
	"./it/card-sets/logistics.json": [
		37224,
		37224
	],
	"./it/card-sets/marketers.json": [
		40295,
		40295
	],
	"./it/card-sets/medicalcoders.json": [
		89622,
		89622
	],
	"./it/card-sets/mepengineers.json": [
		75639,
		75639
	],
	"./it/card-sets/microsoft365.json": [
		59155,
		59155
	],
	"./it/card-sets/mortgagebrokers.json": [
		98255,
		98255
	],
	"./it/card-sets/motiondesigners.json": [
		84035,
		84035
	],
	"./it/card-sets/notaries.json": [
		15258,
		15258
	],
	"./it/card-sets/novels.json": [
		99304,
		99304
	],
	"./it/card-sets/nurses.json": [
		52773,
		52773
	],
	"./it/card-sets/nutritionists.json": [
		26466,
		26466
	],
	"./it/card-sets/officemanagers.json": [
		69779,
		69779
	],
	"./it/card-sets/onlinecoaches.json": [
		1247,
		23628
	],
	"./it/card-sets/paralegals.json": [
		4687,
		4687
	],
	"./it/card-sets/payroll.json": [
		10326,
		10326
	],
	"./it/card-sets/pharmacists.json": [
		75460,
		75460
	],
	"./it/card-sets/photographers.json": [
		99727,
		99727
	],
	"./it/card-sets/physicaltherapists.json": [
		41285,
		41285
	],
	"./it/card-sets/procurement.json": [
		68049,
		68049
	],
	"./it/card-sets/programmers.json": [
		20886,
		20886
	],
	"./it/card-sets/projectmanagers.json": [
		3866,
		3866
	],
	"./it/card-sets/propertymanagers.json": [
		83302,
		83302
	],
	"./it/card-sets/psychologists.json": [
		75240,
		75240
	],
	"./it/card-sets/quantitysurveyors.json": [
		8180,
		8180
	],
	"./it/card-sets/realestate.json": [
		41387,
		41387
	],
	"./it/card-sets/recruiters.json": [
		69245,
		69245
	],
	"./it/card-sets/safetymanagers.json": [
		63629,
		63629
	],
	"./it/card-sets/salesmanagers.json": [
		73087,
		73087
	],
	"./it/card-sets/salonowners.json": [
		65866,
		65866
	],
	"./it/card-sets/shortdramas.json": [
		81809,
		81809
	],
	"./it/card-sets/structuralengineers.json": [
		86968,
		86968
	],
	"./it/card-sets/supplychain.json": [
		80983,
		80983
	],
	"./it/card-sets/supportmanagers.json": [
		94964,
		94964
	],
	"./it/card-sets/surveyors.json": [
		34147,
		34147
	],
	"./it/card-sets/taxadvisors.json": [
		31295,
		31295
	],
	"./it/card-sets/teachers.json": [
		27464,
		27464
	],
	"./it/card-sets/tourguides.json": [
		93568,
		93568
	],
	"./it/card-sets/touroperators.json": [
		10832,
		10832
	],
	"./it/card-sets/travel.json": [
		75163,
		75163
	],
	"./it/card-sets/tutors.json": [
		42394,
		42394
	],
	"./it/card-sets/veterinarians.json": [
		16646,
		16646
	],
	"./it/card-sets/videoeditors.json": [
		19680,
		19680
	],
	"./ja/card-sets/3dartists.json": [
		2182,
		2182
	],
	"./ja/card-sets/accountants.json": [
		21702,
		21702
	],
	"./ja/card-sets/airbnbhosts.json": [
		14198,
		14198
	],
	"./ja/card-sets/analysts.json": [
		5624,
		5624
	],
	"./ja/card-sets/appraisers.json": [
		49773,
		49773
	],
	"./ja/card-sets/architects.json": [
		60955,
		60955
	],
	"./ja/card-sets/auditors.json": [
		13568,
		13568
	],
	"./ja/card-sets/bookkeepers.json": [
		10939,
		10939
	],
	"./ja/card-sets/boss.json": [
		76450,
		76450
	],
	"./ja/card-sets/businessowners.json": [
		71061,
		71061
	],
	"./ja/card-sets/cfo.json": [
		86089,
		86089
	],
	"./ja/card-sets/chiropractors.json": [
		58182,
		58182
	],
	"./ja/card-sets/civilengineers.json": [
		63988,
		63988
	],
	"./ja/card-sets/civilservants.json": [
		51858,
		51858
	],
	"./ja/card-sets/cleaningbusiness.json": [
		91206,
		91206
	],
	"./ja/card-sets/compliance.json": [
		15568,
		15568
	],
	"./ja/card-sets/constructionmanagers.json": [
		42478,
		42478
	],
	"./ja/card-sets/consultants.json": [
		87213,
		87213
	],
	"./ja/card-sets/contractors.json": [
		61543,
		61543
	],
	"./ja/card-sets/cruiseagents.json": [
		72922,
		72922
	],
	"./ja/card-sets/customsbrokers.json": [
		23641,
		23641
	],
	"./ja/card-sets/dentists.json": [
		88463,
		88463
	],
	"./ja/card-sets/designers.json": [
		18633,
		18633
	],
	"./ja/card-sets/ecommercesellers.json": [
		99663,
		99663
	],
	"./ja/card-sets/engineers.json": [
		47445,
		47445
	],
	"./ja/card-sets/estimators.json": [
		58348,
		58348
	],
	"./ja/card-sets/events.json": [
		91734,
		91734
	],
	"./ja/card-sets/excel.json": [
		1048,
		1048
	],
	"./ja/card-sets/executiveassistants.json": [
		74392,
		74392
	],
	"./ja/card-sets/financialadvisors.json": [
		52681,
		52681
	],
	"./ja/card-sets/financiers.json": [
		31541,
		31541
	],
	"./ja/card-sets/fitnesstrainers.json": [
		98817,
		98817
	],
	"./ja/card-sets/freelancers.json": [
		13605,
		13605
	],
	"./ja/card-sets/freightbrokers.json": [
		82576,
		82576
	],
	"./ja/card-sets/general.json": [
		9159,
		9159
	],
	"./ja/card-sets/grantwriters.json": [
		19469,
		19469
	],
	"./ja/card-sets/healthcare.json": [
		38500,
		38500
	],
	"./ja/card-sets/hospitality.json": [
		68565,
		68565
	],
	"./ja/card-sets/hr.json": [
		5013,
		5013
	],
	"./ja/card-sets/insuranceagents.json": [
		30089,
		30089
	],
	"./ja/card-sets/interiordesigners.json": [
		22633,
		22633
	],
	"./ja/card-sets/landscapers.json": [
		84509,
		84509
	],
	"./ja/card-sets/languageteachers.json": [
		84806,
		84806
	],
	"./ja/card-sets/lawyers.json": [
		85634,
		85634
	],
	"./ja/card-sets/loanofficers.json": [
		19890,
		19890
	],
	"./ja/card-sets/logistics.json": [
		36232,
		36232
	],
	"./ja/card-sets/marketers.json": [
		82727,
		82727
	],
	"./ja/card-sets/medicalcoders.json": [
		19990,
		19990
	],
	"./ja/card-sets/mepengineers.json": [
		49175,
		49175
	],
	"./ja/card-sets/microsoft365.json": [
		14771,
		14771
	],
	"./ja/card-sets/mortgagebrokers.json": [
		10319,
		10319
	],
	"./ja/card-sets/motiondesigners.json": [
		38787,
		38787
	],
	"./ja/card-sets/notaries.json": [
		56410,
		56410
	],
	"./ja/card-sets/novels.json": [
		44072,
		44072
	],
	"./ja/card-sets/nurses.json": [
		62341,
		62341
	],
	"./ja/card-sets/nutritionists.json": [
		51234,
		51234
	],
	"./ja/card-sets/officemanagers.json": [
		31475,
		31475
	],
	"./ja/card-sets/onlinecoaches.json": [
		77580,
		77580
	],
	"./ja/card-sets/paralegals.json": [
		60591,
		60591
	],
	"./ja/card-sets/payroll.json": [
		5142,
		5142
	],
	"./ja/card-sets/pharmacists.json": [
		28484,
		28484
	],
	"./ja/card-sets/photographers.json": [
		12815,
		12815
	],
	"./ja/card-sets/physicaltherapists.json": [
		86885,
		86885
	],
	"./ja/card-sets/procurement.json": [
		70449,
		70449
	],
	"./ja/card-sets/programmers.json": [
		16694,
		16694
	],
	"./ja/card-sets/projectmanagers.json": [
		82042,
		82042
	],
	"./ja/card-sets/propertymanagers.json": [
		82854,
		82854
	],
	"./ja/card-sets/psychologists.json": [
		82888,
		82888
	],
	"./ja/card-sets/quantitysurveyors.json": [
		55540,
		55540
	],
	"./ja/card-sets/realestate.json": [
		97003,
		97003
	],
	"./ja/card-sets/recruiters.json": [
		11389,
		11389
	],
	"./ja/card-sets/safetymanagers.json": [
		4941,
		4941
	],
	"./ja/card-sets/salesmanagers.json": [
		83999,
		83999
	],
	"./ja/card-sets/salonowners.json": [
		90890,
		90890
	],
	"./ja/card-sets/shortdramas.json": [
		68113,
		68113
	],
	"./ja/card-sets/structuralengineers.json": [
		38923,
		61304
	],
	"./ja/card-sets/supplychain.json": [
		99575,
		99575
	],
	"./ja/card-sets/supportmanagers.json": [
		40020,
		40020
	],
	"./ja/card-sets/surveyors.json": [
		65155,
		65155
	],
	"./ja/card-sets/taxadvisors.json": [
		77215,
		77215
	],
	"./ja/card-sets/teachers.json": [
		48328,
		48328
	],
	"./ja/card-sets/tourguides.json": [
		88800,
		88800
	],
	"./ja/card-sets/touroperators.json": [
		23760,
		23760
	],
	"./ja/card-sets/travel.json": [
		65659,
		65659
	],
	"./ja/card-sets/tutors.json": [
		91610,
		91610
	],
	"./ja/card-sets/veterinarians.json": [
		42662,
		42662
	],
	"./ja/card-sets/videoeditors.json": [
		47680,
		47680
	],
	"./pt_br/card-sets/3dartists.json": [
		53552,
		53552
	],
	"./pt_br/card-sets/accountants.json": [
		53264,
		53264
	],
	"./pt_br/card-sets/airbnbhosts.json": [
		62860,
		62860
	],
	"./pt_br/card-sets/analysts.json": [
		75850,
		75850
	],
	"./pt_br/card-sets/appraisers.json": [
		30723,
		30723
	],
	"./pt_br/card-sets/architects.json": [
		21809,
		21809
	],
	"./pt_br/card-sets/auditors.json": [
		86426,
		86426
	],
	"./pt_br/card-sets/bookkeepers.json": [
		66270,
		43889
	],
	"./pt_br/card-sets/boss.json": [
		28688,
		28688
	],
	"./pt_br/card-sets/businessowners.json": [
		78995,
		78995
	],
	"./pt_br/card-sets/cfo.json": [
		97103,
		97103
	],
	"./pt_br/card-sets/chiropractors.json": [
		41192,
		41192
	],
	"./pt_br/card-sets/civilengineers.json": [
		40774,
		40774
	],
	"./pt_br/card-sets/civilservants.json": [
		54411,
		76792
	],
	"./pt_br/card-sets/cleaningbusiness.json": [
		99624,
		99624
	],
	"./pt_br/card-sets/compliance.json": [
		80558,
		80558
	],
	"./pt_br/card-sets/constructionmanagers.json": [
		75084,
		75084
	],
	"./pt_br/card-sets/consultants.json": [
		99151,
		99151
	],
	"./pt_br/card-sets/contractors.json": [
		16209,
		16209
	],
	"./pt_br/card-sets/cruiseagents.json": [
		20032,
		20032
	],
	"./pt_br/card-sets/customsbrokers.json": [
		5823,
		5823
	],
	"./pt_br/card-sets/dentists.json": [
		82201,
		82201
	],
	"./pt_br/card-sets/designers.json": [
		33047,
		33047
	],
	"./pt_br/card-sets/ecommercesellers.json": [
		58201,
		58201
	],
	"./pt_br/card-sets/engineers.json": [
		43315,
		43315
	],
	"./pt_br/card-sets/estimators.json": [
		59370,
		59370
	],
	"./pt_br/card-sets/events.json": [
		79728,
		79728
	],
	"./pt_br/card-sets/excel.json": [
		73598,
		73598
	],
	"./pt_br/card-sets/executiveassistants.json": [
		2950,
		2950
	],
	"./pt_br/card-sets/financialadvisors.json": [
		47695,
		47695
	],
	"./pt_br/card-sets/financiers.json": [
		21043,
		21043
	],
	"./pt_br/card-sets/fitnesstrainers.json": [
		42827,
		42827
	],
	"./pt_br/card-sets/freelancers.json": [
		3119,
		3119
	],
	"./pt_br/card-sets/freightbrokers.json": [
		84146,
		84146
	],
	"./pt_br/card-sets/general.json": [
		2493,
		2493
	],
	"./pt_br/card-sets/grantwriters.json": [
		91439,
		91439
	],
	"./pt_br/card-sets/healthcare.json": [
		22978,
		22978
	],
	"./pt_br/card-sets/hospitality.json": [
		67631,
		67631
	],
	"./pt_br/card-sets/hr.json": [
		97567,
		97567
	],
	"./pt_br/card-sets/insuranceagents.json": [
		87427,
		87427
	],
	"./pt_br/card-sets/interiordesigners.json": [
		87607,
		87607
	],
	"./pt_br/card-sets/landscapers.json": [
		13651,
		13651
	],
	"./pt_br/card-sets/languageteachers.json": [
		42020,
		42020
	],
	"./pt_br/card-sets/lawyers.json": [
		24080,
		24080
	],
	"./pt_br/card-sets/loanofficers.json": [
		29952,
		29952
	],
	"./pt_br/card-sets/logistics.json": [
		6598,
		6598
	],
	"./pt_br/card-sets/marketers.json": [
		3913,
		3913
	],
	"./pt_br/card-sets/medicalcoders.json": [
		86172,
		86172
	],
	"./pt_br/card-sets/mepengineers.json": [
		99329,
		99329
	],
	"./pt_br/card-sets/microsoft365.json": [
		30209,
		30209
	],
	"./pt_br/card-sets/mortgagebrokers.json": [
		1801,
		1801
	],
	"./pt_br/card-sets/motiondesigners.json": [
		51549,
		51549
	],
	"./pt_br/card-sets/notaries.json": [
		8312,
		8312
	],
	"./pt_br/card-sets/novels.json": [
		44158,
		44158
	],
	"./pt_br/card-sets/nurses.json": [
		42139,
		42139
	],
	"./pt_br/card-sets/nutritionists.json": [
		20524,
		20524
	],
	"./pt_br/card-sets/officemanagers.json": [
		67793,
		67793
	],
	"./pt_br/card-sets/onlinecoaches.json": [
		33994,
		33994
	],
	"./pt_br/card-sets/paralegals.json": [
		91233,
		91233
	],
	"./pt_br/card-sets/payroll.json": [
		7048,
		7048
	],
	"./pt_br/card-sets/pharmacists.json": [
		13406,
		13406
	],
	"./pt_br/card-sets/photographers.json": [
		69697,
		69697
	],
	"./pt_br/card-sets/physicaltherapists.json": [
		62991,
		62991
	],
	"./pt_br/card-sets/procurement.json": [
		90207,
		90207
	],
	"./pt_br/card-sets/programmers.json": [
		70240,
		70240
	],
	"./pt_br/card-sets/projectmanagers.json": [
		65772,
		65772
	],
	"./pt_br/card-sets/propertymanagers.json": [
		79648,
		79648
	],
	"./pt_br/card-sets/psychologists.json": [
		67230,
		67230
	],
	"./pt_br/card-sets/quantitysurveyors.json": [
		34490,
		34490
	],
	"./pt_br/card-sets/realestate.json": [
		54377,
		54377
	],
	"./pt_br/card-sets/recruiters.json": [
		15775,
		15775
	],
	"./pt_br/card-sets/safetymanagers.json": [
		48051,
		48051
	],
	"./pt_br/card-sets/salesmanagers.json": [
		29777,
		29777
	],
	"./pt_br/card-sets/salonowners.json": [
		36852,
		36852
	],
	"./pt_br/card-sets/shortdramas.json": [
		67471,
		67471
	],
	"./pt_br/card-sets/structuralengineers.json": [
		94526,
		94526
	],
	"./pt_br/card-sets/supplychain.json": [
		26845,
		26845
	],
	"./pt_br/card-sets/supportmanagers.json": [
		34706,
		34706
	],
	"./pt_br/card-sets/surveyors.json": [
		56101,
		56101
	],
	"./pt_br/card-sets/taxadvisors.json": [
		52965,
		52965
	],
	"./pt_br/card-sets/teachers.json": [
		28890,
		28890
	],
	"./pt_br/card-sets/tourguides.json": [
		98446,
		98446
	],
	"./pt_br/card-sets/touroperators.json": [
		55942,
		55942
	],
	"./pt_br/card-sets/travel.json": [
		90961,
		90961
	],
	"./pt_br/card-sets/tutors.json": [
		21692,
		21692
	],
	"./pt_br/card-sets/veterinarians.json": [
		67408,
		67408
	],
	"./pt_br/card-sets/videoeditors.json": [
		16234,
		16234
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 70259;
module.exports = webpackAsyncContext;